<div class="condition-list">
	<ul>
		@for (condition of conditions(); track condition) {
			<li class="condition">{{ translate(condition) | async }}</li>
		}
	</ul>
</div>
